import { useAuth } from '../hooks/useAuth'
import { RedirectToCreateOrg } from './RedirectToCreateOrg'
import { RedirectToSignIn } from './RedirectToSignIn'

export const Protected: React.FC<{
  children: React.ReactNode
  needsOrg: boolean
}> = ({ children, needsOrg }) => {
  const { isSignedIn, session } = useAuth()

  if (!isSignedIn || !session) return <RedirectToSignIn />
  if (needsOrg && !session.currentOrgId) return <RedirectToCreateOrg />
  return <>{children}</>
}
